import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import App from "./App";
import { webLogger } from "./logging/logger";

window.addEventListener("error", (event) => {
  webLogger.error({
    handler: "globalError",
    path: window.location.pathname,
    message: `Global runtime error on page ${window.location.pathname}. Error: ${event.message}`,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  const reason =
    event.reason instanceof Error ? event.reason.message : String(event.reason);

  webLogger.error({
    handler: "unhandledRejection",
    path: window.location.pathname,
    message: `Unhandled promise rejection on page ${window.location.pathname}. Reason: ${reason}`,
  });
});

const root = ReactDOM.createRoot(document.getElementById("root") as Element);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
